import { useState } from 'react';

import { cn, ShigoWordmark } from '@shigo-ui/ui';

import { dashboardT } from '../../lib/messages';
import { useShigoTheme } from '../../lib/useShigoTheme';
import { useNetworkBranding } from './networkBrandingContext';
import { NetworkBrandLogoTone } from './network-brand-logo.types';

type NetworkBrandLogoProps = {
  className?: string;
  height: number;
  tone: NetworkBrandLogoTone;
};

export function NetworkBrandLogo({ className, height, tone }: NetworkBrandLogoProps) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const { resolvedTheme } = useShigoTheme();
  const branding = useNetworkBranding();
  const source =
    tone === NetworkBrandLogoTone.Light || resolvedTheme === 'dark'
      ? branding.logoLightUrl
      : branding.logoUrl;
  const label = dashboardT('brand.logoAlt', { network: branding.displayName });

  if (failedSource === source || !source) {
    return <ShigoWordmark className={className} height={height} label={branding.displayName} />;
  }

  return (
    <img
      alt={label}
      className={cn('block max-w-full object-contain object-left', className)}
      height={height}
      onError={() => {
        setFailedSource(source);
      }}
      src={source}
    />
  );
}
